import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { formName } from "../Constants/constants";
import initialFormValues from "../Constants/initialFormValues";
import Form from "../Components/Form/Form";
import {
  providersValidation,
  underwritingQuestionsValidation,
} from "@gbli-events/common/src/Helpers/validators";
import { resolveQueryParams } from "Actions/actions";
import { checkBoilerplateReferral } from "Actions/boilerplate";

const FormContainer = reduxForm({
  form: formName,
  initialValues: initialFormValues(),
  validate: (values) => {
    let errors = {};
    const providers = providersValidation(values);
    if (providers) errors = { ...providers };
    const underwritingQuestions = underwritingQuestionsValidation(values);
    if (underwritingQuestions) errors = { ...errors, ...underwritingQuestions };

    if (errors) return errors;

    return Object.values(errors).length ? errors : undefined;
  },
  shouldError: () => true,
})(Form);

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  resolveQueryParams: (value) => {
    dispatch(resolveQueryParams(value));
  },
  checkBoilerplateReferral: (search) => {
    dispatch(checkBoilerplateReferral(search));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
